import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { BreakdownItem } from '../components/group-breakdown-kpi-widget/group-breakdown-kpi-widget.component';

/**
 * Interface for inventory breakdown data
 */
export interface InventoryBreakdownData {
  totalValue: number;
  breakdownItems: BreakdownItem[];
}

/**
 * Service to provide inventory breakdown data by location
 */
@Injectable({
  providedIn: 'root'
})
export class InventoryBreakdownService {
  /**
   * Get inventory breakdown data by location
   * In a real application, this would fetch from an API
   */
  getInventoryBreakdownData(): Observable<InventoryBreakdownData> {
    // Mock data - replace with actual API call
    const mockData: InventoryBreakdownData = {
      totalValue: 180000,
      breakdownItems: [
        { label: 'Location MIA', value: 50000 },
        { label: 'Location BOS', value: 35000 },
        { label: 'Location NY', value: 30000 },
        { label: 'Location LAX', value: 25000 },
        { label: 'Location CHI', value: 20000 }
      ]
    };

    // Simulate API delay
    return of(mockData).pipe(delay(100));
  }

  /**
   * Get inventory breakdown data for a specific filter
   * @param filter Optional filter criteria (e.g., region, category)
   */
  getFilteredBreakdownData(filter?: string): Observable<InventoryBreakdownData> {
    // In a real application, this would apply filters to the API request
    return this.getInventoryBreakdownData();
  }
}
